// extracted by mini-css-extract-plugin
export default {"wrapper":"ExpandableText_wrapper__Pp23v","content":"ExpandableText_content__wVJjY","more":"ExpandableText_more__vMMbw","button":"ExpandableText_button__HC1Cq"};